import { createSlice } from '@reduxjs/toolkit'

export interface UiState {
	isCartDrawerOpen: boolean
}

const initialState: UiState = {
	isCartDrawerOpen: false,
}

const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		toggleCartDrawer(state) {
			state.isCartDrawerOpen = !state.isCartDrawerOpen
		},
		closeCartDrawer(state) {
			state.isCartDrawerOpen = false
		},
	},
})

export const { toggleCartDrawer, closeCartDrawer } = uiSlice.actions
export default uiSlice.reducer
